var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$store.state.loading
        ? _c("loading-anim", {
            attrs: { active: _vm.$store.state.loading, fullScreen: "" }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.form.state.errors
        ? _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.submitError) } })
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmSucessful
        ? _c(
            "div",
            [
              _c("p", [_vm._v(_vm._s(_vm.$t("account.confirm-account-h1")))]),
              _vm._v(" "),
              !_vm.passwordUpdated
                ? _c(
                    "base-button",
                    {
                      staticClass: "mt-3",
                      on: { click: _vm.goToUpdatePassword }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("account.password-update.set-password"))
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        : _vm.confirmSucessful === false
        ? _c(
            "div",
            [
              _c("p", [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("account.confirm-account.steps-reenable")) +
                    " "
                )
              ]),
              _vm._v(" "),
              _c("base-input", {
                attrs: { placeholder: "Email" },
                model: {
                  value: _vm.emailResend,
                  callback: function($$v) {
                    _vm.emailResend = $$v
                  },
                  expression: "emailResend"
                }
              }),
              _vm._v(" "),
              _c(
                "base-button",
                { staticClass: "mt-3", on: { click: _vm.resendEmail } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("account.confirm-account.resend-enable-account")
                    )
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5cd5c90f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5cd5c90f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/account/ConfirmEmail.vue
// module id = 4143
// module chunks = 56